
<dropdown
  :align="align"
  :active="menuOpen"
  @close="menuOpen = false"
>
  <pill
    v-if="showPill"
    sortable
    :tooltip="activeOption ? activeOption.tooltip : tooltip"
    @click.native="menuOpen = !menuOpen"
  >
    {{ activeOption ? activeOption.label : label }}
  </pill>

  <template #menu>
    <dropdown-menu
      :options="options"
      @select="handleSelect"
    />
  </template>
</dropdown>
